import { Card, CardBody, Col } from "reactstrap";
import { Badges, Btn } from "../../../AbstractElements";
import { PositionedBadgesTitle } from "../../../Constants/Constants";
import { PositionedBadgesData, PositionedBadgesSubTitle } from "../../../Data/UiKits/Tag&Pills";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const PositionedBadges = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={PositionedBadgesTitle} span={PositionedBadgesSubTitle} />
        <CardBody>
          <div className="badge-flex">
            {PositionedBadgesData.map((item, index) => (
              <Btn color={item.color} className={`position-relative ${item.buttonClass}`} key={index}>
                {item.icon ? <i className={`fa fa-${item.icon}`} /> : item.title}
                <Badges pill color="danger" className={`position-absolute top-0 start-100 translate-middle ${item.badgesClass}`}>
                  {item.text ? item.text : <span className="visually-hidden">New alerts</span>}
                </Badges>
              </Btn>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default PositionedBadges;
